export default "__VITE_ASSET__CiW1SXv5__"